<template>
  <div class='information'>
    <div class="intro-y box lg">
      <div
        class="flex items-center p-5 border-b border-gray-200 dark:border-dark-5"
      >
        <h2 class="font-medium text-base mr-auto">消息动态</h2>
      </div>
      <div class="mt-5">
        <div
          v-for="(item,index) in messageList" 
          :key="index"
          @click="toAssetDetails(item)"
          class="intro-y"
        >
          <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
            <div class="ml-4 mr-auto">
              <div class="font-medium news-content">
                <span class="news-tit">{{item.userName}}</span>
                <span class="news-tit">{{item.operateTypeDesc}}</span>
                <span class="news-company">{{item.manageEnterpriseName}}-</span>
                <span class="news-add">{{item.certificateAddress}}</span>
              </div>
              <div class="text-gray-600 text-xs">
                {{item.operateTime}}
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5">
      <el-pagination
        layout="prev, pager, next"
        :background='false'
        :page-size="5"
        :current-page='page'
        @current-change='currentChange'
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {messageGetList} from '../../../api/workbench.js'
  export default {
    name: "information",
    components: {},
    data() {
      return {
        messageList:[],
        loading:false,
        page:1,
        total: 0,
      }
    },
    methods: {
      currentChange(page){
        this.page=page;
        this.getMessageList();
      },
      getMessageList(){
        let para = {
          page:this.page,
          perPage:5,
        }
        this.loading = true
        messageGetList(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.messageList = data.content.list
            this.total = data.content.total
          } else {
            
          }
        }).catch(err => {
          console.log(err);
          this.loading = false
        }).finally(() => {
          this.loading = false
        })
      },
      toAssetDetails(params){
        if(params.operateTypeDesc == '编辑合同信息' || params.operateTypeDesc == '新增合同信息'){
          this.$router.push({path:'/assetManagement/assetDetail',query:{assetId:params.assetId,activeKey:'contract'}})
        }else if(params.operateTypeDesc == '新增资产' || params.operateTypeDesc == '编辑资产'){
          this.$router.push({path:'/assetManagement/assetDetail',query:{assetId:params.assetId}})
        }
      }
    },
    created() {
      this.getMessageList()
    },
  }
</script>

<style scoped lang="scss">
  .information {
    .news-content {
      display: flex;
      margin-bottom: 5px;
      .news-tit {
        font-size: 16px;
        font-weight: 600;
        margin-right: 20px;
      }
      .news-company {
        font-size: 16px;
        font-weight: 600;
        color: #1890ff;
      }
      .news-add {
        font-size: 12px;
        font-weight: 400;
        color: #1890ff;
        line-height:24px;
      }
      .footer {
        
      }
    }
    .page{
      margin-top: 15px;
    }
  }
</style>
